/*
 * "משהו קטן וטוב" campaign page — hero video, the moments row, the way into
 * the inquiry (sheet on phones, the in-page form on desktop), the floating
 * inquiry and the forms themselves. Rendered by every sg-* section; runs once.
 */
(() => {
  if (window.__sgReady) return;
  window.__sgReady = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const calm = reduceMotion || Boolean(navigator.connection && navigator.connection.saveData); // no autoplay
  const behavior = reduceMotion ? "auto" : "smooth";
  const small = () => innerWidth < 1024;
  const whenLoaded = (fn) => (document.readyState === "complete" ? fn() : addEventListener("load", fn, { once: true }));

  // Analytics: names + choices only, never personal details. The lead
  // conversion itself still fires on the thank-you page, after a real 2xx.
  const track = (name, params = {}) => {
    try { if (typeof window.gtag === "function") window.gtag("event", name, params); } catch (_) {}
  };

  // the moment picked in the moments row travels with every form
  let pickedMoment = "";
  const showMoment = () => {
    $$("[data-sg-moment-pick]").forEach((el) => {
      el.hidden = !pickedMoment;
      const name = $("[data-sg-moment-name]", el);
      if (name) name.textContent = pickedMoment;
    });
  };
  $$("[data-sg-moment-clear]").forEach((b) => b.addEventListener("click", () => {
    pickedMoment = "";
    showMoment();
    const name = b.form && b.form.elements.fullName; // the × hid itself: keep focus in this form
    if (name) name.focus();
  }));

  /* ---------- the way into the inquiry ---------- */
  const sheet = $("[data-sg-sheet]");
  const lead = $("#sg-lead");
  let place = () => {};
  let opener = null;
  // phones/tablets: the short form in a sheet; desktop: scroll to the form.
  // The page's form switched off: the site's "צרו איתנו קשר" popup (mk-footer listens).
  const openLead = (from) => {
    if (small() && sheet) { opener = from || document.activeElement; sheet.showModal(); place(); return true; }
    if (!lead) { dispatchEvent(new CustomEvent("mk:contact", { detail: { variant: "business" } })); return true; }
    lead.scrollIntoView({ behavior, block: "center" });
    const name = $("#sg-fullName");
    if (name) name.focus({ preventScroll: true });
    return true;
  };
  $$("[data-sg-cta]").forEach((a) => a.addEventListener("click", (e) => {
    track("sg_cta_click", { location: a.dataset.sgCta + (small() && sheet ? "-sheet" : "") });
    if (a.hasAttribute("data-sg-link")) return; // a link picked in the customizer: just go there
    if (openLead(a)) e.preventDefault();
  }));

  /* ---------- phones: the hero's floating button ---------- */
  // Steps aside while the site footer (its own contact band) is on screen; off
  // when the page's own form is on (that one brings its own floating button).
  const fab = $("[data-sg-fab]");
  if (fab) {
    const foot = $(".shopify-section-group-mk-footer-group");
    if (lead) fab.hidden = true;
    else if (foot) new IntersectionObserver(([e]) => fab.classList.toggle("is-away", e.isIntersecting)).observe(foot);
  }

  /* ---------- hero video ---------- */
  const heroMedia = $("[data-sg-video]");
  if (heroMedia) {
    const video = $("video", heroMedia);
    const btn = $("[data-sg-video-toggle]", heroMedia);
    let pausedByUser = calm; // reduced motion / Save-Data: poster until asked
    const setBtn = (playing) => {
      btn.classList.toggle("is-paused", !playing);
      btn.setAttribute("aria-label", playing ? btn.dataset.labelPause : btn.dataset.labelPlay);
    };
    const play = () => {
      if (!video.getAttribute("src")) video.src = small() ? video.dataset.srcMobile : video.dataset.srcDesktop;
      const p = video.play();
      if (p) p.catch(() => setBtn(false)); // autoplay refused: the poster stays
    };
    video.addEventListener("playing", () => { heroMedia.classList.add("is-playing"); setBtn(true); });
    video.addEventListener("pause", () => setBtn(false));
    // the same button stills the scrolling logo row (WCAG 2.2.2)
    const band = heroMedia.closest(".sg-hero__band");
    btn.hidden = false;
    setBtn(false);
    if (band) band.classList.toggle("is-still", pausedByUser); // calm visitors start with both still
    btn.addEventListener("click", () => {
      if (video.paused) { pausedByUser = false; play(); } else { pausedByUser = true; video.pause(); }
      if (band) band.classList.toggle("is-still", pausedByUser);
    });
    whenLoaded(() => setTimeout(() => new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { if (!pausedByUser) play(); } else if (!video.paused) video.pause();
    }, { threshold: 0.25 }).observe(heroMedia), 200));
  }

  /* ---------- moments: the red frame, the moments slide into its card ---------- */
  // Every slide (the card's and the small ones on their way) sits on its
  // offset from the moment in the card: 0 = in it, ±1 = next / previous… on a
  // ring, so it never ends; a slide that wraps around jumps instead of
  // crossing. The moment in the card plays its video and shows its words.
  // Moves on by itself while on screen, unless pointed at, focused, swiped or
  // paused; calm visitors move it with the arrows / swipe. A click on the card
  // opens the inquiry with the moment.
  const gift = $("[data-sg-gift]");
  const giftHit = $("[data-sg-gift-go]");
  if (gift && giftHit) {
    const front = $$(".sg-gift__card .sg-gift__slide", gift);
    const back = $$(".sg-gift__back .sg-gift__slide", gift);
    const caps = $$(".sg-gift__cap", gift);
    const shine = $(".sg-gift__shine", gift);
    const btn = $("[data-sg-gift-toggle]", gift);
    const n = front.length;
    const phone = () => innerWidth < 768;
    let at = 0, pausedByUser = calm;
    const place = (els) => els.forEach((el, j) => {
      let o = (((j - at) % n) + n) % n;
      if (o > n / 2) o -= n;
      const was = el.dataset.o === undefined ? o : Number(el.dataset.o);
      el.classList.toggle("is-jump", Math.abs(o - was) > 1);
      el.style.setProperty("--o", o);
      el.dataset.o = o;
    });
    const show = (k) => {
      at = ((k % n) + n) % n;
      place(front);
      place(back);
      caps.forEach((c, j) => c.classList.toggle("is-on", j === at));
      giftHit.setAttribute("aria-label", caps[at] ? caps[at].dataset.label : "");
      front.forEach((sl, j) => {
        const v = $("video", sl);
        if (!v) return;
        if (j === at && !calm && !phone()) { // phones: photos only — the hero's film is enough motion
          if (!v.getAttribute("src")) v.src = v.dataset.src;
          v.addEventListener("playing", () => sl.classList.add("is-playing"), { once: true });
          const p = v.play();
          if (p) p.catch(() => {});
        } else v.pause();
      });
      if (shine) { shine.classList.remove("is-on"); void shine.offsetWidth; shine.classList.add("is-on"); }
    };
    let last = Date.now();
    const step = (d) => { last = Date.now(); show(at + d); };
    const prev = $("[data-sg-prev]", gift);
    const next = $("[data-sg-next]", gift);
    if (prev) prev.addEventListener("click", () => step(-1));
    if (next) next.addEventListener("click", () => step(1));
    // swipe: RTL — the next moment waits on the left, so dragging right brings it in
    let x0 = null;
    gift.addEventListener("pointerdown", (e) => { x0 = e.clientX; }, { passive: true });
    gift.addEventListener("pointerup", (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { step(dx > 0 ? 1 : -1); gift.dataset.swiped = "1"; }
    });
    giftHit.addEventListener("click", () => {
      if (gift.dataset.swiped) { delete gift.dataset.swiped; return; } // the end of a swipe is not a click
      pickedMoment = caps[at] ? caps[at].dataset.sgMoment || "" : "";
      showMoment();
      track(pickedMoment ? "sg_moment_select" : "sg_cta_click", pickedMoment ? { moment: pickedMoment } : { location: "moments-end" });
      openLead(giftHit);
    });
    const setBtn = () => {
      btn.classList.toggle("is-paused", pausedByUser);
      btn.setAttribute("aria-label", pausedByUser ? btn.dataset.labelPlay : btn.dataset.labelPause);
    };
    if (btn) { btn.hidden = false; setBtn(); btn.addEventListener("click", () => { pausedByUser = !pausedByUser; last = Date.now(); setBtn(); }); }
    let hold = false, seen = false;
    gift.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") hold = true; });
    gift.addEventListener("pointerleave", () => { hold = false; });
    gift.addEventListener("focusin", () => { hold = true; });
    gift.addEventListener("focusout", () => { hold = false; });
    new IntersectionObserver(([e]) => { seen = e.isIntersecting; }, { threshold: 0.5 }).observe(gift);
    setInterval(() => {
      if (seen && !hold && !pausedByUser && !document.hidden && Date.now() - last > 4000) step(1);
    }, 4800);
    show(0);
  }

  /* ---------- steps: the cards come in one after the other, once ---------- */
  $$("[data-sg-easy]").forEach((root) => {
    if (calm) return;
    root.classList.add("is-waiting");
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      root.classList.replace("is-waiting", "is-in");
      io.disconnect();
    }, { threshold: 0.3 });
    io.observe(root);
  });

  /* ---------- treats: on phones each photo takes turns with its brands' logos ---------- */
  // All cards switch together on one slow beat (each to its own next logo).
  const cyclers = $$("[data-sg-cycle]").filter((m) => $(".sg-treat__alt", m));
  if (cyclers.length && !calm) {
    const phone = matchMedia("(max-width: 767px)");
    let beat = 0; // 0 = the photos, n = each card's n-th logo
    setInterval(() => {
      if (!phone.matches || document.hidden) return;
      beat++;
      cyclers.forEach((m) => {
        const alts = $$(".sg-treat__alt", m);
        const at = beat % (alts.length + 1);
        alts.forEach((img, j) => img.classList.toggle("is-on", j === at - 1));
      });
    }, 4200);
  }

  /* ---------- floating inquiry (desktop bar / mobile button + sheet) ---------- */
  // Shown only between the hero's button and the closing band (hidden the
  // moment the band peeks in), so exactly one form is ever on screen — unless
  // the visitor is typing in it or it shows a send error. The desktop bar can
  // be closed for the session.
  const float = $("[data-sg-float]");
  const heroCta = $('[data-sg-cta="hero"]');
  if (float && heroCta && lead) {
    let dismissed = false;
    try { dismissed = sessionStorage.getItem("sg-float-x") === "1"; } catch (_) {}
    let tick = false;
    place = () => {
      tick = false;
      const busy = float.contains(document.activeElement) || $$("[data-sg-status]", float).some((el) => !el.hidden);
      const between = heroCta.getBoundingClientRect().bottom < 0 && lead.getBoundingClientRect().top > innerHeight - 16;
      float.hidden = !(busy || (between && !(sheet && sheet.open) && !(dismissed && !small())));
    };
    const x = $("[data-sg-float-x]", float);
    if (x) x.addEventListener("click", () => {
      dismissed = true;
      try { sessionStorage.setItem("sg-float-x", "1"); } catch (_) {}
      place();
      if (giftHit) giftHit.focus({ preventScroll: true }); // keyboard users continue from the moments card, not the page top
    });
    addEventListener("scroll", () => { if (!tick) { tick = true; requestAnimationFrame(place); } }, { passive: true });
    addEventListener("resize", place);
    place();
  }
  if (sheet) {
    $$("[data-sg-sheet-close]", sheet).forEach((b) => b.addEventListener("click", () => sheet.close()));
    sheet.addEventListener("click", (e) => { if (e.target === sheet) sheet.close(); }); // tap on the backdrop
    sheet.addEventListener("close", () => {
      place();
      // the opener may have been hidden while the sheet was open: give focus back
      const ae = document.activeElement;
      if (opener && opener.isConnected && (!ae || ae === document.body || sheet.contains(ae))) opener.focus({ preventScroll: true });
    });
  }

  /* ---------- the inquiry forms ---------- */
  // Israeli phone: 05x/07x + 7 digits or a 9-digit landline; +972 accepted.
  const normalizePhone = (v) => {
    let d = v.replace(/[^\d+]/g, "");
    if (d.startsWith("+972")) d = "0" + d.slice(4);
    else if (d.startsWith("972")) d = "0" + d.slice(3);
    return d.replace(/\D/g, "");
  };
  const rules = {
    fullName: (v) => v.trim().length >= 2,
    company: (v) => v.trim().length >= 2,
    phone: (v) => /^0(?:5\d{8}|7\d{8}|[2-489]\d{7})$/.test(normalizePhone(v)),
  };
  const utm = () => {
    const q = new URLSearchParams(location.search);
    const out = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => { if (q.get(k)) out[k] = q.get(k); });
    return out;
  };

  $$("[data-sg-form]").forEach((form) => {
    const status = $("[data-sg-status]", form);
    const submit = $("[data-sg-submit]", form);
    const done = $("[data-sg-done]", form);
    const where = form.closest("[data-sg-float]") ? "float-bar" : form.closest("[data-sg-sheet]") ? "float-sheet" : "page";
    let busy = false;
    let started = false;
    form.addEventListener("focusin", () => { if (!started) { started = true; track("sg_form_start", { form: where }); } });

    const showErr = (input, bad) => {
      input.setAttribute("aria-invalid", String(bad));
      const err = document.getElementById(`${input.id}-err`);
      if (err) err.hidden = !bad;
    };
    Object.keys(rules).forEach((name) => {
      const input = form.elements[name];
      input.addEventListener("input", () => { if (input.getAttribute("aria-invalid") === "true" && rules[name](input.value)) showErr(input, false); });
    });

    const buildLead = () => {
      const f = form.elements;
      const lines = [
        `פנייה מעמוד הקמפיין "${form.dataset.campaign}"`,
        pickedMoment && `רגע: ${pickedMoment}`,
      ].filter(Boolean);
      return {
        fullName: f.fullName.value.trim(),
        company: f.company.value.trim(),
        phone: normalizePhone(f.phone.value),
        email: "",
        description: lines.join("\n"),
        audience: "business",
        marketingConsent: String(Boolean(f.marketingConsent && f.marketingConsent.checked)),
        campaign: form.dataset.campaign,
        // the page's campaign source → the CRM's "מקור קמפיין" (snippets/mk-campaign-source.liquid)
        pcfcampsourc: ($('meta[name="xtra-campaign-source"]') || {}).content || form.dataset.campaign,
        moment: pickedMoment,
        pageUrl: location.origin + location.pathname,
        ...(window.mkLeadUtm ? window.mkLeadUtm() : utm()),
      };
    };
    const send = async (data) => {
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), 15000);
      try {
        if (!form.dataset.webhook) throw new Error("no destination");
        const res = await fetch(form.dataset.webhook, {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data), signal: ctrl.signal,
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
      } finally { clearTimeout(timer); }
    };
    const setBusy = (on) => {
      busy = on;
      submit.disabled = on;
      $(".sg-btn__label", submit).hidden = on;
      $(".sg-btn__busy", submit).hidden = !on;
    };

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (busy) return;
      status.hidden = true;
      let firstBad = null;
      Object.keys(rules).forEach((name) => {
        const input = form.elements[name];
        const bad = !rules[name](input.value);
        showErr(input, bad);
        if (bad && !firstBad) firstBad = input;
      });
      if (firstBad) { firstBad.focus(); return; }
      if (form.elements.website.value) { done.hidden = false; return; } // bot trap

      setBusy(true);
      try {
        await send(buildLead());
        track("sg_lead_sent", { form: where, moment: pickedMoment || "none" });
        const to = form.dataset.success;
        if (to) { location.assign(to + (to.includes("?") ? "&" : "?") + "source=small-good"); return; }
        done.hidden = false;
        done.focus();
      } catch (_) {
        status.hidden = false; // nothing is cleared: details stay for a retry
        track("sg_lead_failed", { form: where });
      }
      setBusy(false);
      if (!status.hidden) submit.focus();
    });
  });

  showMoment();
})();
